import PriceBreakdownToggleSFC from "./PriceBreakdownToggle.vue";

export type { IPriceBreakdownToggleProps } from "./props";
export const PriceBreakdownToggle = PriceBreakdownToggleSFC;
